import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueEasyLightbox from 'vue-easy-lightbox'
// import i18n from './helpers/Lang'
import { library, config, dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { BASE_URL } from './helpers/constant'

// add lightbox
Vue.use(VueEasyLightbox)
Vue.component(VueEasyLightbox.name, VueEasyLightbox)

// add font awesome
library.add(fas)
library.add(fab)
// allow to use font awesome in pseudo-elements
config.searchPseudoElements = true;
dom.watch()
Vue.component('font-awesome-icon', FontAwesomeIcon)


// init axios
window.axios = axios.create({
  baseURL: BASE_URL
})
window.axios.defaults.headers.common['accept-language'] = 'en';

Vue.config.productionTip = false
new Vue({
  router,
  store,
  // i18n,
  render: h => h(App)
}).$mount('#app')
